import React, { useState, useEffect } from "react";
import { models, Report, Embed, service, Page } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import styles from "./Powerbi.module.css";
import axios from "axios";
import ContentLoader from "../loader/ContentLoader";
import {
  BASE_URL,
  BASE_URL_PBIX_REPORT,
  OCP_APIM_SUBSCRIPTION_KEY,
  USER_ROLE_ID,
} from "../../constants/constant";
import { setButtonAction, setHeader } from "../../reduxSlices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  downloadReport,
  getAllPackageByOrganisationId,
  updateSelectedReport,
} from "../../reduxSlices/packageSlice";
import { savePdf } from "../../helpers/helper";
import Footer from "../footer/Footer";
import DisclaimerDialog from "../dialog/DisclaimerDialog";

const Powerbi = () => {
  const dispatch = useDispatch();
  const [responseConfig, setResponseConfig] = useState({});
  const [report, setReport] = useState(null);
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showDefinition, setShowDefinition] = useState(false);

  const { reportTitle, groupId, reportId, profileId } = useParams();

  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const orgId = currentUser?.organization?.organizationId;
  const reportsData = useSelector(
    (state) => state?.package?.allPackageByOrganisationId?.reportsData
  );
  const selectedReport = reportsData?.filter(
    (data) => data.pbReportId === reportId
  );

  console.log("selectedReport<<<<", selectedReport);

  useEffect(() => {
    const fetchResponse = async () => {
      if (groupId && reportId && profileId) {
        setLoader(true);
        const url = `${BASE_URL}/api/Report/GetPowerBIEmbedToken`;
        const params = {
          profileId: profileId,
          groupId: groupId,
          reportId: reportId,
        };
        const user_token = localStorage.getItem("bb_access_token");
        await axios
          // .get(
          //   `${BASE_URL_PBIX_REPORT}&groupId=${groupId}&reportId=${reportId}&profileId=${profileId}`,
          //   {
          //     headers: {
          //       "Content-Type": "application/json",
          //     },
          //   }
          // )
          .get(url, {
            params,
            headers: {
              "Content-Type": "application/json",
              "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
              Authorization: "Bearer  " + user_token,
            },
          })
          .then((response) => {
            const data = response?.data?.data;
            dispatch(
              setHeader({
                page: "powerbi",
                title: "",
                subTitle: "",
                lastUpdated: data?.lastUpdated,
              })
            );
            console.log("vduvjvsjs", data);
            if (data) {
              setLoader(false);
              setResponseConfig(data);
              setIsEmbedded(true);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.error("Error exchanging code for access token:", error);
          });
      }
    };
    getReportData();
    fetchResponse();
  }, [groupId, reportId, profileId]);

  const exportReport = async () => {
    const filters = await getAllActiveFilters();
    if (groupId && reportId && profileId) {
      try {
        const obj = {
          groupId: groupId,
          reportId: reportId,
          profileId: profileId,
          reportTitle: reportTitle,
          filters: filters,
        };
        await dispatch(downloadReport(obj));
      } catch (error) {
        console.error("Error fetching PDF data:", error);
      }
    }
  };

  useEffect(() => {
    if (buttonAction.page === "powerbi" && buttonAction.action === "export") {
      console.log("buttonAction called");
      exportReport();
    } else if (
      buttonAction.page === "powerbi" &&
      buttonAction.action === "showinfo"
    ) {
      setShowDefinition(true);
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const getReportData = async () => {
    if (orgId) {
      const obj = {
        searchText: "",
        orgId: orgId || "",
      };
      await dispatch(getAllPackageByOrganisationId(obj));
    }
  };

  useEffect(() => {
    if (selectedReport?.length) {
      dispatch(updateSelectedReport(selectedReport[0]));
    }
  }, [selectedReport]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "powerbi",
        title: "",
        subTitle: "",
      })
    );
  }, []);

  const handleGoBack = () => {
    setShowDefinition(false);
  };

  const getAllActiveFilters = async () => {
    if (!report) return null;

    // 1. Report Filters
    const reportFilters = await report.getFilters();

    // 2. Page Filters
    const pages = await report.getPages();
    const activePage = pages.find((p) => p.isActive);
    const pageFilters = await activePage.getFilters();

    // 3. Slicer Filters
    const visuals = await activePage.getVisuals();
    const slicers = visuals.filter((v) => v.type === "slicer");

    const slicerStates = await Promise.all(
      slicers.map((s) => s.getSlicerState())
    );

    return {
      reportFilters,
      pageFilters,
      slicers: slicerStates,
    };
  };

  if (loader) return <ContentLoader />;

  return (
    <>
      {isEmbedded ? (
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: responseConfig.reportId,
            embedUrl: responseConfig.embedUrl,
            accessToken: responseConfig.embedToken,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.All,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
              background: models.BackgroundType.Transparent,
            },
          }}
          eventHandlers={
            new Map([
              [
                "loaded",
                function () {
                  console.log("Report loaded");
                },
              ],
              [
                "rendered",
                function () {
                  console.log("Report rendered");
                },
              ],
              [
                "error",
                function (event) {
                  console.log(event.detail);
                },
              ],
              ["visualClicked", () => console.log("visual clicked")],
              ["pageChanged", (event) => console.log(event)],
            ])
          }
          cssClassName={styles.reportContainer}
          getEmbeddedComponent={(embeddedReport) => {
            setReport(embeddedReport);
          }}
        />
      ) : null}
      <DisclaimerDialog
        open={showDefinition}
        setOpen={setShowDefinition}
        handleDone={handleGoBack}
        onClose={false}
        title="Definitions"
        subTitle="Item1 - Lorem ipsum dolor sit amet. Qui voluptas reiciendis cum consectetur magnam qui voluptatum voluptas eos dolor suscipit qui praesentium dolores est suscipit officiis.<br />
        Item2 - Lorem ipsum dolor sit amet. Qui voluptas reiciendis cum consectetur magnam qui voluptatum voluptas eos dolor suscipit qui praesentium dolores est suscipit officiis.<br />
        Item2 - Lorem ipsum dolor sit amet. Qui voluptas reiciendis cum consectetur magnam qui voluptatum voluptas eos dolor suscipit qui praesentium dolores est suscipit officiis."
        rightButtonText="Ok"
      />
    </>
  );
};
export default Powerbi;
